import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close\">\n  <rect x=\"1\" y=\"1\" width=\"19.3677\" height=\"19.3677\" rx=\"9.68384\" stroke=\"#3F2390\" stroke-width=\"2\" />\n  <path d=\"M13.6962 14L8 8M8.30375 14L14 8\" stroke=\"#3F2390\" stroke-width=\"2\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol